export var SharePointServicePrincipal = "00000003-0000-0ff1-ce00-000000000000";
export var SPOAuthEnv;
(function (SPOAuthEnv) {
    SPOAuthEnv[SPOAuthEnv["SPO"] = 0] = "SPO";
    SPOAuthEnv[SPOAuthEnv["China"] = 1] = "China";
    SPOAuthEnv[SPOAuthEnv["Germany"] = 2] = "Germany";
    SPOAuthEnv[SPOAuthEnv["USDef"] = 3] = "USDef";
    SPOAuthEnv[SPOAuthEnv["USGov"] = 4] = "USGov";
})(SPOAuthEnv || (SPOAuthEnv = {}));
//# sourceMappingURL=types.js.map